import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

//import components
// import ItemNextPrev from './ItemNextPrev.js';
import BackButton from './BackButton.js';

const ItemNavigation = ({ clang, history, showBackButton }) => {
    return (
        <div className="item__navigation">
            <BackButton history={history} showBackButton={showBackButton} />
            {/* <ItemNextPrev /> */}
        </div>
    );
};

ItemNavigation.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemNavigation);



// WEBPACK FOOTER //
// ./src/components/items/ItemNavigation.js